import React, { Component } from 'react';
import ActionsCard from './actionscard';

class SmallActions extends Component {

  render() {
    return (
      <section id="small-actions-section">
        <div className="container">
          <div className="row">
            <div className="col12">
              <h2>Small Actions</h2>
              <h3>Have a Big Impact</h3>
              <p>You don’t have to save the world to be a superhero in a child’s life.<br/> Small moments matter.</p>
            </div>
          </div>
          <div className="row">
            <ActionsCard/>
          </div>
        </div>
      </section>
    );
  }
}

export default SmallActions;


// WEBPACK FOOTER //
// ./src/components/smallactions/smallactions.js